export const getCouponApply = (couponCode: string) => (state: any) => {
  return state.quote.couponApply[couponCode] ?? {}
}
